import React from 'react';
import './Footer.scss';
import {Link} from "react-router-dom"; // 确保你也创建了一个Footer.css来包含样式

// 关于多媒体注释部分，参考scss的footer-container的justify-content
const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-contact-info">
                    <p>MajorityAI - Pragmatic AI for Real Results</p>
                    {/* <p>Address: Mt Albert, Auckland,1025</p> */}
                    {/*<p>Tel: (123) 456-7890</p>*/}
                    <p>Email: connorxiong.ai@gmail.com</p>

                    <p><Link to='/term' className="text-link">Website Terms of Use</Link></p>

                </div>

            </div>
        </footer>
    );
};

export default Footer;
